import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';

const Main = () => {
    return (
        <div className='flex flex-col max-h-screen'>
            <Navbar />
            <div
                className={'content border-box flex flex-col justify-stretch'
                + ' align-stretch max-h-screen grow overflow-y-auto'}
            >
                <Outlet />
            </div>
        </div>
    );
};

export default Main;
